/** Lock the document scroll owner and disable background content while searching. */
export function lockSearchBackground(): () => void {
  const root = document.documentElement;
  const scrollbarGutter = root.style.scrollbarGutter;
  const elements = [document.documentElement, document.body];
  const styles = elements.map((element) => ({
    element,
    overflow: element.style.overflow,
    overscrollBehavior: element.style.overscrollBehavior,
  }));
  const background = Array.from(
    document.querySelectorAll<HTMLElement>('#root main, #root footer'),
  ).map((element) => ({ element, inert: element.inert }));
  for (const { element } of styles) {
    // The document owns page scrolling. Making body a scroll container breaks
    // the sticky header when search opens below the top of the page.
    if (element === root) element.style.overflow = 'hidden';
    element.style.overscrollBehavior = 'none';
  }
  root.style.scrollbarGutter = 'stable';
  for (const { element } of background) element.inert = true;

  return () => {
    root.style.scrollbarGutter = scrollbarGutter;
    for (const { element, overflow, overscrollBehavior } of styles) {
      element.style.overflow = overflow;
      element.style.overscrollBehavior = overscrollBehavior;
    }
    for (const { element, inert } of background) element.inert = inert;
  };
}
